import { GridCustomRowProps } from '@progress/kendo-react-grid';
import { memo, useCallback, type FocusEvent } from 'react';

interface RowRenderProps extends GridCustomRowProps {
  exitEdit: () => void;
}

const RowRenderInner = ({ trProps, children, exitEdit }: RowRenderProps) => {
  const handleBlur = useCallback(
    (event: FocusEvent<HTMLTableRowElement>) => {
      const currentRow = event.currentTarget;
      const existingOnBlur = trProps?.onBlur;

      if (existingOnBlur) {
        existingOnBlur(event);
      }
      // To prevent blur trigger on dropdown
      requestAnimationFrame(() => {
        const activeElement = document.activeElement;

        if (!(activeElement instanceof Element)) {
          exitEdit();
          return;
        }

        if (currentRow.contains(activeElement)) {
          return;
        }

        const isMuiDropdownFocus =
          activeElement.closest('[role="listbox"], [role="option"]') !== null ||
          document.querySelector('[role="listbox"]:focus-within') !== null;

        if (isMuiDropdownFocus) {
          return;
        }

        exitEdit();
      });
    },
    [trProps?.onBlur, exitEdit]
  );

  return (
    <tr {...trProps} onBlur={handleBlur}>
      {children}
    </tr>
  );
};

export const RowRender = memo(RowRenderInner);

RowRender.displayName = 'RowRender';
